const BillMixCannedResponse =
{
    "ALPHA": {
        "echo": [
            {
                "blue": [
                    {
                        "workstations": [
                            {
                                "invalid": true,
                                "id": "T4VATM97"
                            }
                        ],
                        "errorType": ""
                    }
                ],
                "green": [
                    {
                        "workstations": [
                            {
                                "invalid": false,
                                "id": "T4VATM97",
                                "fastcash_billmix": "LEAST_BILL",
                                "withdrawal_billmix": "LEAST_BILL"
                            }
                        ],
                        "errorType": ""
                    }
                ]
            }
        ]
    },
    "OMEGA": {
        "echo": [
            {
                "blue": [
                    {
                        "workstations": [
                            {
                                "invalid": true,
                                "id": "T4VATM97"
                            }
                        ],
                        "errorType": ""
                    }
                ],
                "green": [
                    {
                        "workstations": [
                            {
                                "invalid": true,
                                "id": "T4VATM97"
                            }
                        ],
                        "errorType": ""
                    }
                ]
            }
        ]
    }
}
export default BillMixCannedResponse;
// {
//     "ALPHA": {
//         "echo": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": false,
//                                 "id": "SVE21893",
//                                 "fastcash_billmix": "LEAST_BILL",
//                                 "withdrawal_billmix": "LEAST_BILL"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "SVE41472",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "SVE41812",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "T4VATM97"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "T4VATM98"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM99",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": false,
//                                 "id": "SVE21893",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "SVE41472",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "SVE41812",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM97",
//                                 "fastcash_billmix": "LEAST_BILL",
//                                 "withdrawal_billmix": "LEAST_BILL"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM98",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM99",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LEAST_BILL"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ]
//             }
//         ],
//         "sierra": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [],
//                         "errorType": "RemoteServiceException Failed due to httpstatuscode: {\"serviceName\":\"billmixapi\",\"uriName\":\"GetBillMix\",\"uri\":\"https://o53bcjk87a.execute-api.us-east-1.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=blue\\u0026workstations=[T4VATM97,T4VATM98,T4VATM99,SVE21893,SVE41472,SVE41812]\",\"path\":\"https://o53bcjk87a.execute-api.us-east-1.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=blue\\u0026workstations=[T4VATM97,T4VATM98,T4VATM99,SVE21893,SVE41472,SVE41812]\",\"requestContent\":null,\"resultContent\":\"{\\u0022errorMessage\\u0022: {\\u0022errors\\u0022: [{\\u0022code\\u0022: \\u00227\\u0022, \\u0022source\\u0022: \\u0022lambda_handler\\u0022, \\u0022message\\u0022: \\u0022Unprocessable Entity\\u0022, \\u0022detail\\u0022: \\u0022\\u0022}]}}\",\"statusCode\":422}"
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [],
//                         "errorType": "RemoteServiceException Failed due to httpstatuscode: {\"serviceName\":\"billmixapi\",\"uriName\":\"GetBillMix\",\"uri\":\"https://o53bcjk87a.execute-api.us-east-1.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=green\\u0026workstations=[T4VATM97,T4VATM98,T4VATM99,SVE21893,SVE41472,SVE41812]\",\"path\":\"https://o53bcjk87a.execute-api.us-east-1.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=green\\u0026workstations=[T4VATM97,T4VATM98,T4VATM99,SVE21893,SVE41472,SVE41812]\",\"requestContent\":null,\"resultContent\":\"{\\u0022errorMessage\\u0022: {\\u0022errors\\u0022: [{\\u0022code\\u0022: \\u00227\\u0022, \\u0022source\\u0022: \\u0022lambda_handler\\u0022, \\u0022message\\u0022: \\u0022Unprocessable Entity\\u0022, \\u0022detail\\u0022: \\u0022\\u0022}]}}\",\"statusCode\":422}"
//                     }
//                 ]
//             }
//         ],
//         "tango": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": true,
//                                 "id": "SVE21893"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "SVE41472"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "SVE41812",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST",
//                                 "processing_center": "ALPHA",
//                                 "deployment": "BLUE"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM97",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LEAST_BILL",
//                                 "processing_center": "ALPHA",
//                                 "deployment": "GREEN"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM98",
//                                 "fastcash_billmix": "TWENTIES_FIRST",
//                                 "withdrawal_billmix": "TWENTIES_FIRST",
//                                 "processing_center": "ALPHA",
//                                 "deployment": "GREEN"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM99",
//                                 "fastcash_billmix": "TWENTIES_FIRST",
//                                 "withdrawal_billmix": "TWENTIES_FIRST",
//                                 "processing_center": "ALPHA",
//                                 "deployment": "GREEN"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": true,
//                                 "id": "SVE21893"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "SVE41472"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "SVE41812",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST",
//                                 "processing_center": "ALPHA",
//                                 "deployment": "BLUE"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM97",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LEAST_BILL",
//                                 "processing_center": "ALPHA",
//                                 "deployment": "GREEN"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM98",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LEAST_BILL",
//                                 "processing_center": "ALPHA",
//                                 "deployment": "GREEN"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM99",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LEAST_BILL",
//                                 "processing_center": "ALPHA",
//                                 "deployment": "GREEN"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ]
//             }
//         ]
//     },
//     "OMEGA": {
//         "echo": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": true,
//                                 "id": "SVE21893"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "SVE41472"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "SVE41812"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "T4VATM97"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "T4VATM98"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "T4VATM99"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": false,
//                                 "id": "SVE21893",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "SVE41472",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "SVE41812",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "T4VATM97"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "T4VATM98"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "T4VATM99"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ]
//             }
//         ],
//         "sierra": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [],
//                         "errorType": "RemoteServiceException Failed due to httpstatuscode: {\"serviceName\":\"billmixapi\",\"uriName\":\"GetBillMix\",\"uri\":\"https://0ks8yrbwj8.execute-api.us-east-2.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=blue\\u0026workstations=[T4VATM97,T4VATM98,T4VATM99,SVE21893,SVE41472,SVE41812]\",\"path\":\"https://0ks8yrbwj8.execute-api.us-east-2.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=blue\\u0026workstations=[T4VATM97,T4VATM98,T4VATM99,SVE21893,SVE41472,SVE41812]\",\"requestContent\":null,\"resultContent\":\"{\\u0022errorMessage\\u0022: {\\u0022errors\\u0022: [{\\u0022code\\u0022: \\u00227\\u0022, \\u0022source\\u0022: \\u0022lambda_handler\\u0022, \\u0022message\\u0022: \\u0022Unprocessable Entity\\u0022, \\u0022detail\\u0022: \\u0022\\u0022}]}}\",\"statusCode\":422}"
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [],
//                         "errorType": "RemoteServiceException Failed due to httpstatuscode: {\"serviceName\":\"billmixapi\",\"uriName\":\"GetBillMix\",\"uri\":\"https://0ks8yrbwj8.execute-api.us-east-2.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=green\\u0026workstations=[T4VATM97,T4VATM98,T4VATM99,SVE21893,SVE41472,SVE41812]\",\"path\":\"https://0ks8yrbwj8.execute-api.us-east-2.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=green\\u0026workstations=[T4VATM97,T4VATM98,T4VATM99,SVE21893,SVE41472,SVE41812]\",\"requestContent\":null,\"resultContent\":\"{\\u0022errorMessage\\u0022: {\\u0022errors\\u0022: [{\\u0022code\\u0022: \\u00227\\u0022, \\u0022source\\u0022: \\u0022lambda_handler\\u0022, \\u0022message\\u0022: \\u0022Unprocessable Entity\\u0022, \\u0022detail\\u0022: \\u0022\\u0022}]}}\",\"statusCode\":422}"
//                     }
//                 ]
//             }
//         ],
//         "tango": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": true,
//                                 "id": "SVE21893"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "SVE41472"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "SVE41812",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM97",
//                                 "fastcash_billmix": "TWENTIES_FIRST",
//                                 "withdrawal_billmix": "TWENTIES_FIRST"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM98",
//                                 "fastcash_billmix": "TWENTIES_FIRST",
//                                 "withdrawal_billmix": "TWENTIES_FIRST"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM99",
//                                 "fastcash_billmix": "TWENTIES_FIRST",
//                                 "withdrawal_billmix": "TWENTIES_FIRST"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": true,
//                                 "id": "SVE21893"
//                             },
//                             {
//                                 "invalid": true,
//                                 "id": "SVE41472"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "SVE41812",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LOW_BILL_FIRST"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM97",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LEAST_BILL"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM98",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LEAST_BILL"
//                             },
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM99",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LEAST_BILL"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ]
//             }
//         ]
//     }
// };

// export default BillMixCannedResponse;

// {
//     "ALPHA": {
//         "echo": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": true,
//                                 "id": "T4VATM97"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM97",
//                                 "fastcash_billmix": "TWENTIES_FIRST",
//                                 "withdrawal_billmix": "TWENTIES_FIRST"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ]
//             }
//         ],
//         "sierra": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [],
//                         "errorType": "RemoteServiceException Failed due to httpstatuscode: {\"serviceName\":\"billmixapi\",\"uriName\":\"GetBillMix\",\"uri\":\"https://o53bcjk87a.execute-api.us-east-1.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=blue\\u0026workstations=[T4VATM97]\",\"path\":\"https://o53bcjk87a.execute-api.us-east-1.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=blue\\u0026workstations=[T4VATM97]\",\"requestContent\":null,\"resultContent\":\"{\\u0022errorMessage\\u0022: {\\u0022errors\\u0022: [{\\u0022code\\u0022: \\u00227\\u0022, \\u0022source\\u0022: \\u0022lambda_handler\\u0022, \\u0022message\\u0022: \\u0022Unprocessable Entity\\u0022, \\u0022detail\\u0022: \\u0022\\u0022}]}}\",\"statusCode\":422}"
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [],
//                         "errorType": "RemoteServiceException Failed due to httpstatuscode: {\"serviceName\":\"billmixapi\",\"uriName\":\"GetBillMix\",\"uri\":\"https://o53bcjk87a.execute-api.us-east-1.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=green\\u0026workstations=[T4VATM97]\",\"path\":\"https://o53bcjk87a.execute-api.us-east-1.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=green\\u0026workstations=[T4VATM97]\",\"requestContent\":null,\"resultContent\":\"{\\u0022errorMessage\\u0022: {\\u0022errors\\u0022: [{\\u0022code\\u0022: \\u00227\\u0022, \\u0022source\\u0022: \\u0022lambda_handler\\u0022, \\u0022message\\u0022: \\u0022Unprocessable Entity\\u0022, \\u0022detail\\u0022: \\u0022\\u0022}]}}\",\"statusCode\":422}"
//                     }
//                 ]
//             }
//         ],
//         "tango": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM97",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LEAST_BILL",
//                                 "processing_center": "ALPHA",
//                                 "deployment": "GREEN"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM97",
//                                 "fastcash_billmix": "LOW_BILL_FIRST",
//                                 "withdrawal_billmix": "LEAST_BILL",
//                                 "processing_center": "ALPHA",
//                                 "deployment": "GREEN"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ]
//             }
//         ]
//     },
//     "OMEGA": {
//         "echo": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": true,
//                                 "id": "T4VATM97"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": true,
//                                 "id": "T4VATM97"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ]
//             }
//         ],
//         "sierra": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [],
//                         "errorType": "RemoteServiceException Failed due to httpstatuscode: {\"serviceName\":\"billmixapi\",\"uriName\":\"GetBillMix\",\"uri\":\"https://0ks8yrbwj8.execute-api.us-east-2.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=blue\\u0026workstations=[T4VATM97]\",\"path\":\"https://0ks8yrbwj8.execute-api.us-east-2.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=blue\\u0026workstations=[T4VATM97]\",\"requestContent\":null,\"resultContent\":\"{\\u0022errorMessage\\u0022: {\\u0022errors\\u0022: [{\\u0022code\\u0022: \\u00227\\u0022, \\u0022source\\u0022: \\u0022lambda_handler\\u0022, \\u0022message\\u0022: \\u0022Unprocessable Entity\\u0022, \\u0022detail\\u0022: \\u0022\\u0022}]}}\",\"statusCode\":422}"
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [],
//                         "errorType": "RemoteServiceException Failed due to httpstatuscode: {\"serviceName\":\"billmixapi\",\"uriName\":\"GetBillMix\",\"uri\":\"https://0ks8yrbwj8.execute-api.us-east-2.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=green\\u0026workstations=[T4VATM97]\",\"path\":\"https://0ks8yrbwj8.execute-api.us-east-2.amazonaws.com/dev/billmix?callsign=sierra\\u0026connectUser=rbhess\\u0026color=green\\u0026workstations=[T4VATM97]\",\"requestContent\":null,\"resultContent\":\"{\\u0022errorMessage\\u0022: {\\u0022errors\\u0022: [{\\u0022code\\u0022: \\u00227\\u0022, \\u0022source\\u0022: \\u0022lambda_handler\\u0022, \\u0022message\\u0022: \\u0022Unprocessable Entity\\u0022, \\u0022detail\\u0022: \\u0022\\u0022}]}}\",\"statusCode\":422}"
//                     }
//                 ]
//             }
//         ],
//         "tango": [
//             {
//                 "blue": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM97",
//                                 "fastcash_billmix": "TWENTIES_FIRST",
//                                 "withdrawal_billmix": "TWENTIES_FIRST"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ],
//                 "green": [
//                     {
//                         "workstations": [
//                             {
//                                 "invalid": false,
//                                 "id": "T4VATM97",
//                                 "fastcash_billmix": "TWENTIES_FIRST",
//                                 "withdrawal_billmix": "TWENTIES_FIRST"
//                             }
//                         ],
//                         "errorType": ""
//                     }
//                 ]
//             }
//         ]
//     }

// "ALPHA": {
//     "blue": [
//         {
//             "workstations": [
//                 {
//                     "invalid": false,
//                     "id": "SVE21893",
//                     "fastcash_billmix": "TWENTIES_FIRST",
//                     "withdrawal_billmix": "TWENTIES_FIRST",
//                     "processing_center": "ALPHA",
//                     "deployment": "green"
//                 },
//                 {
//                     "invalid": false,
//                     "id": "SVE41472",
//                     "fastcash_billmix": "TWENTIES_FIRST",
//                     "withdrawal_billmix": "TWENTIES_FIRST",
//                     "processing_center": "OMEGA",
//                     "deployment": "green"
//                 },
//                 {
//                     "invalid": false,
//                     "id": "SVE41812",
//                     "fastcash_billmix": "TWENTIES_FIRST",
//                     "withdrawal_billmix": "TWENTIES_FIRST",
//                     "processing_center": "OMEGA",
//                     "deployment": "blue"
//                 },
//                 {
//                     "invalid": true,
//                     "id": "T4VATM97"
//                 },
//                 {
//                     "invalid": true,
//                     "id": "T4VATM98"
//                 },
//                 {
//                     "invalid": false,
//                     "id": "T4VATM99",
//                     "fastcash_billmix": "TWENTIES_FIRST",
//                     "withdrawal_billmix": "TWENTIES_FIRST"
//                 }
//             ],
//         }
//     ],
//     "green": [
//         {
//             "workstations": [
//                 {
//                     "invalid": false,
//                     "id": "SVE21893",
//                     "fastcash_billmix": "TWENTIES_FIRST",
//                     "withdrawal_billmix": "TWENTIES_FIRST"
//                 },
//                 {
//                     "invalid": false,
//                     "id": "SVE41472",
//                     "fastcash_billmix": "TWENTIES_FIRST",
//                     "withdrawal_billmix": "TWENTIES_FIRST"
//                 },
//                 {
//                     "invalid": false,
//                     "id": "SVE41812",
//                     "fastcash_billmix": "TWENTIES_FIRST",
//                     "withdrawal_billmix": "TWENTIES_FIRST"
//                 },
//                 {
//                     "invalid": false,
//                     "id": "T4VATM97",
//                     "fastcash_billmix": "LOW_BILL_FIRST",
//                     "withdrawal_billmix": "LEAST_BILL"
//                 },
//                 {
//                     "invalid": false,
//                     "id": "T4VATM98",
//                     "fastcash_billmix": "LOW_BILL_FIRST",
//                     "withdrawal_billmix": "LEAST_BILL"
//                 },
//                 {
//                     "invalid": false,
//                     "id": "T4VATM99",
//                     "fastcash_billmix": "LOW_BILL_FIRST",
//                     "withdrawal_billmix": "LEAST_BILL"
//                 }
//             ],
//         }
//     ]
// },
// "OMEGA": {
//     "blue": [
//         {
//             "invalid": true,
//             "id": "T4VATM99",
//         }
//     ],
//     "green": [
//         {
//             "workstations": [],
//             "errorType": "HttpRequestException"
//         }
//     ]
// }
